import { createClient } from 'contentful'
import { Config } from '@chegg-wt/core/config'

export const contentfulClient = createClient({
  space: Config.contentfulSpaceId,
  accessToken: Config.contentfulAccessToken,
  environment: Config.contentfulEnv,
})
